// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"3fafacbf","293":"91c87c7c","516":"7dcd7b0e","917":"880e767e","946":"9d1e156b"}[chunkId] + ".chunk.js";
};